import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';

import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';

import { setFreeHand } from 'app/actions/FullTour/full_tour_view.action';

let isStartDraw = true;

const FreeHand = (props) => {
  const { isEmptyPart } = props;
  const dispatch = useDispatch();
  const { isActiveFreeHand } = useSelector((state) => state.tourFullData);

  useEffect(() => {
    return () => {
      isStartDraw = true;
    };
  }, []);

  const startDrawRoute = (start = false) => {
    if (start) {
      isStartDraw = false;
    }
    dispatch(setFreeHand(true));
    publish(way.DRIVE_MAP_SHOW_FREE_HAND_LAYER, {});
  };

  const endDrawRoute = () => {
    dispatch(setFreeHand(false));
    publish(way.DRIVE_MAP_HIDE_FREE_HAND_LAYER, {});
  };

  const GetButton = ({ action, tr, start = false }) => (
    <Button
      type="primary"
      className="freeHandActiveBtn"
      size="large"
      onClick={() => action(start)}
    >
      <span>
        <FormattedMessage id={tr} defaultMessage={tr} />
      </span>
    </Button>
  );

  const getLayout = () => {
    if (isActiveFreeHand) {
      return <GetButton action={endDrawRoute} tr="END DRAW ROUTE" />;
    }

    if (!isActiveFreeHand && !isEmptyPart() && !isStartDraw) {
      return <GetButton action={startDrawRoute} tr="CONTINUE DRAW ROUTE" />;
    }

    return <GetButton action={startDrawRoute} tr="START DRAW ROUTE" start />;
  };

  return <div className="freeHandLayout">{getLayout()}</div>;
};

export default FreeHand;
